import React from "react";
import SectionTitle from "./SectionTitle";
import { useSiteClients } from "../hooks/useSiteData";

export default function Clients() {
  const { clients } = useSiteClients();

  const loop = [...clients, ...clients];

  if (clients.length === 0) return null;

  return (
    <section className="py-20 bg-slate-50 border-y border-slate-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-10">
        <SectionTitle
          align="center"
          eyebrow="Meet Our clintele"
          title="Our Valued Clients"
          // subtitle="We have worked with some of the most reputed organisations in India."
        />
      </div>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-slate-50 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-slate-50 to-transparent z-10" />
        <div className="flex marquee gap-6 w-max">
          {loop.map((client, i) => (
            <div
              key={`${client.id}-${i}`}
              className="flex h-28 w-52 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white px-6 py-5 shadow-sm transition-all hover:border-[#aad4fa] hover:shadow-md"
            >
              <img
                src={client.iconUrl}
                alt={client.name || "Client logo"}
                className="h-full w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
